// Shared time utilities for rapportini
// Use minute-based math to avoid float precision issues

export const calcMinutes = (inizio, fine) => {
  if (!inizio || !fine) return 0;
  const [h1, m1] = String(inizio).split(':').map(Number);
  const [h2, m2] = String(fine).split(':').map(Number);
  if ([h1, m1, h2, m2].some(v => Number.isNaN(v))) return 0;
  let diff = (h2 * 60 + m2) - (h1 * 60 + m1);
  if (diff < 0) diff += 24 * 60; // overnight
  return diff;
};

export const calcHoursDecimal = (inizio, fine) => {
  const min = calcMinutes(inizio, fine);
  return Math.round((min / 60) * 100) / 100;
};

// Format minutes as "HH:MMh"
export const formatMinutes = (totalMinutes) => {
  const m = Math.max(0, Math.round(totalMinutes));
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return `${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}h`;
};

// Format from decimal hours OR from start/end (preferred, no float drift)
export const formatHours = (decimalOrZero, ora_inizio, ora_fine) => {
  if (ora_inizio && ora_fine) {
    return formatMinutes(calcMinutes(ora_inizio, ora_fine));
  }
  const decimal = parseFloat(decimalOrZero) || 0;
  if (decimal <= 0) return '00:00h';
  return formatMinutes(Math.round(decimal * 60));
};
